import { HomepageArticles } from './HomepageArticles'

export default HomepageArticles
